import { createRoutine } from 'app/common/utils/new-routines';
import type { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { type ActionType, createReducer } from 'typesafe-actions';
import { getSchemaVersionList } from '../api';

export const SCHEMA_HISTORY_NAME = 'schemaHistory';
export type SchemaHistorySlice = {
  [SCHEMA_HISTORY_NAME]: SchemaHistory;
};

export type SchemaHistory = {
  loaded: boolean;
  loading: boolean;
  versions: {
    total: number;
    items: Version[];
  };
  errors: string[];
};
export const schemaHistoryInitialState: SchemaHistory = {
  loaded: false,
  loading: false,
  versions: {
    total: 0,
    items: []
  },
  errors: []
};

export type Version = {
  version: number;
  updated: string;
  shapeCount: number;
  queryCount: number;
  mutationCount: number;
  workflowCount?: number;
  defaultLocale?: string;
  locales?: string[];
};

export type SchemaHistoryRequest = {
  from?: number;
  size?: number;
};

export type SchemaHistoryResponse = {
  versionList: {
    total: number;
    items: Version[];
  };
};

export const getSchemaHistoryRoutine = createRoutine('schema/GET_SCHEMA_HISTORY')<
  undefined,
  SchemaHistoryRequest,
  undefined,
  SchemaHistoryResponse,
  string,
  undefined
>();

export function* getSchemaHistorySaga(payload: SchemaHistoryRequest): SagaIterator {
  const schemaVersionList: SchemaHistoryResponse = yield call(getSchemaVersionList, payload);
  return schemaVersionList;
}

export type Action = ActionType<typeof getSchemaHistoryRoutine>;

export const historyReducer = createReducer<SchemaHistory, Action>(schemaHistoryInitialState)
  .handleAction(getSchemaHistoryRoutine.requested, (state) => ({
    ...state,
    loaded: false,
    loading: true
  }))
  .handleAction(getSchemaHistoryRoutine.fulfilled, (state, action) => ({
    ...state,
    loaded: true,
    loading: false,
    versions: action.payload.versionList
  }))
  .handleAction(getSchemaHistoryRoutine.rejected, (state, action) => ({
    ...state,
    loaded: true,
    loading: false,
    errors: [action.payload]
  }));
